export const USPVariantCModuleName = 'USP Variant C';